import React from 'react'
import styles from './Championship.module.css'
import LiveGame from './LiveGame'
import { LiveChampionships, Lives } from '../types';
import { toggleChampionship } from '../LiveSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../app/store'

interface Props extends LiveChampionships {
  style: React.CSSProperties
  additionalResults: Boolean
  showSportType: Boolean
}
const Championship = ({
  Name,
  ChampClass,
  TypeId,
  championatId,
  Games,
  additionalResults,
  style,
  showSportType
}: Props) => {
  const dispatch = useDispatch()
  let isCollapsed = useSelector((state: RootState) =>
    state.liveGames.collapsedChampionships.includes(championatId)
  )

  const headClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    dispatch(toggleChampionship({ championatId }))
  }
  return (
    <div style={style}>
      <div
        className={`${styles.head} ${isCollapsed ? styles.collapsed : ''}  ${showSportType ? styles.withSportType : ''}`}
        onClick={headClick}
      >
        {showSportType ? <span className={`${styles.sportType} MobSportType${TypeId}`}></span> : ''}
        <span className={`${styles.countryIcon} ${ChampClass}`} style={{
          backgroundImage: `url(https://crystalstatic.com/Mobile/content/img/common/new/LIveBetting/live-new/${ChampClass}.svg)`}}></span>
        {Name}
      </div>
      {!isCollapsed
        ? Games.map((game: Lives) => (
            <LiveGame
              key={game.Id}
              Id={game.Id}
              fav={game.fav}
              t1={game.t1}
              t2={game.t2}
              r1={game.r1}
              r2={game.r2}
              time={game.time}
              plusses={game.plusses}
              oddCount={game.oddCount}
              status={game.status}
              stream={game.stream}
              ar={game.ar}
              additionalResults={additionalResults}
              championshipId={championatId}
              sportTypeId={TypeId}
              Odds={game.Odds}
            />
          ))
        : ''}
    </div>
  )
}

export default React.memo(Championship)